import http from '../../utils/http';

export default {
    /**
     * 获取用户信息
     *
     * @returns
     */
    getUserInfo() {
        return http({
            url: 'user',
            method: 'GET'
        });
    }
};
